import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'bcac-single-select-icon',
  templateUrl: './bcac-single-select-icon.component.html',
  styleUrls: ['./bcac-single-select-icon.component.scss']
})
export class BcacSingleSelectIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  visible: boolean = false;
  closeDropDownMenu() {
    this.visible = false;
  }
  iconType = "axis-scale";
  @Input()
  set bcacIconType(value: string) {
    this.iconType = value;
  }

  tooltipTitle = "刻度";
  @Input()
  set bcacTooltipTitle(value: string) {
    this.tooltipTitle = value;
  }

  dropMenuPanelWidth = "10rem";
  @Input()
  set bcacDropMenuPanelWidth(value: string) {
    this.dropMenuPanelWidth = value;
  }

  selectValue: { value: string, label: string}[] = [];
  @Input()
  set bcacSelectData(value: {value: string, label: string}[]) {
    this.selectValue = value;
    this.radioValue = this.selectValue.length > 0? this.selectValue[0].value: null;
    this.bcacSelectedEmit.emit(this.radioValue);
  }

  @Output()
  bcacSelectedEmit = new EventEmitter<any>();
  clickRadio(item: {value: string, label: string}) {
    this.bcacSelectedEmit.emit(item);
  }
  radioValue;
  selectedChange() {
    this.bcacSelectedEmit.emit(this.radioValue);
  }
}
